<template>
  <div class="wg-row" style="height:100%;">
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <div class="wg-row" style="overflow-x:auto;padding:10px 0;">
        <div v-if="rooms.length > 1" class="display-flex" style="flex-wrap:nowrap;">
          <div
              v-for="(r,index) in rooms"
              :key="'room-'+index"
              :class="['display-flex', 'room-button', roomId === r.id ? 'selected' : '' ]"
              @click="selectRoom(r.id)"
          >{{ r.name }}</div>
        </div>
        <div v-else class="com-anm22-app-text-xl">{{ rooms.find(r => r.id === roomId).name }}</div>
      </div>
      <div
        v-if="canViewList"
        class="display-flex"
        style="flex-wrap:nowrap;align-items:center;"
      >
        <img
          :src="$anm22.icons.getWorldIcon('grid')"
          class="com-anm22-app-img-fixed-height-l"
          :style="{cursor: 'pointer', opacity: view === 'list' ? '0.3' : '1'}"
          @click="view = 'map'"
        >
        <div style="border-right:1px solid #ccc;height:40px;margin:0 10px;"></div>
        <img
          :src="$anm22.icons.getWorldIcon('list')"
          class="com-anm22-app-img-fixed-height-l"
          :style="{cursor: 'pointer', opacity: view === 'map' ? '0.3' : '1', marginRight: '10px'}"
          @click="view = 'list'"
      >
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <template v-if="view === 'map'">
      <div
          class="wg-row com-anm22-food-scrolling-panel com-anm22-food-tables-map"
          style="height:calc(100% - 60px);overflow:auto;"
      >
        <table-elem
            v-for="(t) in tables.filter(t => t.room == roomId)"
            :key="'table-'+t.id"
            :table="t"
            :freeFn="freeFn"
            :occupiedFn="occupiedFn"
            :view="'map'"
        ></table-elem>
      </div>
    </template>
    <template v-else>
      <div
          class="wg-row"
          style="height:calc(100% - 60px);"
      >
        <!-- Visualizzazione lista -->
        <w-g-list
            :pagination="false"
            :keyField="'id'"
            :headerItems="headerItems"
            :itemsToDisplay="tableItems"
        >
          <template v-slot:default="{ element }">
            <table-elem
                :table="element"
                :freeFn="freeFn"
                :occupiedFn="occupiedFn"
                view="list"
            ></table-elem>
          </template>
        </w-g-list>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGList from '../../../../../world/spa/components/WGList.vue';
import TableElem from './TableElem.vue';

export default {
  props: {
    canViewList: {
      type: Boolean,
      default: false
    },
    tableRef: [Number, String],
    freeFn: Function,
    occupiedFn: Function
  },
  components: {
    TableElem,
    WGList
  },
  data() {
    return {
      loading: true,
      view: 'map',
      roomId: null,
      table: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      selectedLicense: state => state.licenseSelected,
      windowHeight: state => state.windowHeight
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.selectedLicense);
    },
    rooms() {
      return this.$store.getters['foodRooms/getByLicense'](this.license.id).filter(r => !r.deleted);
    },
    tables() {
      return this.$store.getters['foodTables/getByLicense'](this.license.id).filter(t => !t.deleted);
    },
    // List view
    headerItems() {
      return [
        {
          field: 'name',
          label: this.$anm22.strLang(this.lang, 'Table', 'Tavolo'),
          class: 'wg-xs-12',
          disabled: false,
        }
      ];
    },
    tableItems() {
      return this.tables.filter(t => t.room === this.roomId).map(t => {
        return {
          ...t,
          'list-metadata': {
            type: 'item'
          }
        }
      });
    }
  },
  methods: {
    selectRoom(roomId) {
      this.roomId = roomId;
    },
    // isOccupied(table) {
    //   return this.$store.getters['foodOrders/getByTable'](table.id)
    //       .reduce((r,o) => {
    //         return r || (o.status !== 6 && o.status !== 2 && !o.payed);
    //       }, false);
    // },
    // tableClick(table) {
    //   // !this.isOccupied(table) ? this.freeFn(table) : this.occupiedFn(
    //   !table.isOccupied ? this.freeFn(table) : this.occupiedFn(
    //     this.$store.getters['foodOrders/getByTable'](table.id)
    //       .sort((a,b) => b.id - a.id)[0]
    //   );
    // }
  },
  created() {
    if(this.tableRef) {
      this.table = this.tables.find(t => t.id === this.tableRef);
      this.roomId = this.table.room;
    } else {
      this.roomId = this.rooms.length > 0 ? this.rooms[0].id : null;
    }
    if(this.canViewList) {
      //Cerco il cookie di visualizzazione della mappa/lista
    }
  }
}
</script>

<style lang="scss" scoped>
.room-button {
  height: 40px;
  box-shadow: 0 0 0 2px #ddd;
  border-radius: 5px;
  padding: 5px 10px;
  margin: 0 5px;
  cursor: pointer;
  font-size: 16px;
  flex-wrap: nowrap;
  align-items:center;
  &.selected {
    color: white;
    background-color: #90A4AE;
  }
}
</style>
